import React from "react"
import styled from "styled-components"
import media from "styled-media-query"

const Wrap = styled.div`
  margin: 23px -3px 0 -3px;
  ${media.greaterThan("small")`
    margin: 44px -3px 0 -3px;
  `}
`
const StyledTitle = styled.h1`
  color: #141414;
  font-size: 8.1vw;
  font-weight: 700;
  margin: 6px 0 0 0;
  letter-spacing: 0.5px;
  ${media.greaterThan("small")`
    font-size: 40px;
    height: 60px;
    margin: 8px 0 0 0;
  `}
`
const EnTitle = styled.div`
  color: #0145a2;
  display: flex;
  font-family: "Teko", sans-serif;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1.2px;
  margin-left: 3px;
  width: 100%;
  ${media.greaterThan("small")`
    letter-spacing: 1.58px;
  `}
`
const StyledSubTitle = styled.p`
  font-size: 13px;
  margin: 0;
  ${media.greaterThan("small")`
    font-size: 18px;
  `}
`
const StyledSpan = styled.span`
  border-bottom: solid 1px #ccdaee;
  display: block;
  flex: 1;
  margin: 4px 8px 4px 4px;
  width: 100%;
  ${media.greaterThan("small")`
    margin: 4px 28px 4px 4px;
  `}
`

const TitleSet = props => {
  const title = props.title
  const subTitle = props.subTitle
  const enTitle = props.enTitle
  return (
    <Wrap>
      <EnTitle>
        <p style={{ margin: 0 }}>{enTitle}</p>
        <StyledSpan />
      </EnTitle>
      <StyledTitle>{title}</StyledTitle>
      <StyledSubTitle>{subTitle}</StyledSubTitle>
    </Wrap>
  )
}

export default TitleSet
